module.exports = __webpack_public_path__ + "media/images/front/banner_product-2b73060f222f9999fc8f1912fa9423f8.jpg";